import React, { useState, useEffect } from 'react';
import {
  Radio,
  Divider,
  Space,
  Alert,
  Row,
  Col,
  Typography,
  Card,
  Skeleton,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { openDB } from 'idb';
import { axiosClient } from '../../apiClient';

const { Paragraph } = Typography;

export default function BuyerListShipping(props) {
  const dispatch = useDispatch();
  const [shippingOptions, setShippingOptions] = useState([]);
  const [radioSelected, setRadioSelected] = useState(false);
  const [hasLargeDimensions, setHasLargeDimensions] = useState(false);
  const activeCEP = useSelector((state) => state.activeCEP);
  const buyerView = useSelector((state) => state.buyerView.buyerView);
  const logged = useSelector((state) => state.authentication.logged);
  const [loading, setLoading] = useState(true);
  const cart = useSelector((state) => state.cart);
  const orderRebuy = useSelector((state) => state.orderRebuy);
  const onlineStatus = useSelector((state) => state.sync.onlineStatus);
  const syncStatus = useSelector((state) => state.sync.syncStatus);

  async function getSingleData(dBStoreName, idx) {
    const db = await openDB('nupedido', 1);
    const value = await db.get(dBStoreName, idx);
    return value;
  }

  useEffect(() => {
    if ((buyerView || logged == 'buyer') && (activeCEP.value || (!onlineStatus && syncStatus === 'synced')) && cart.products && cart.products.length) {
      setRadioSelected(false);
      dispatch({
        type: 'ADD_SHIPPING',
        shippingMethod: null,
      });
      setLoading(true);
      if (cart.returned || orderRebuy) {
        if (onlineStatus) {
          axiosClient
            .post(
              '/shipping/buyer/get',
              {
                activeCEP: activeCEP.value,
                buyerId: buyerView ? buyerView.id : null,
                uf: activeCEP.uf,
                cart: orderRebuy ? cart : null,
              },
              { withCredentials: true },
            )
            .then((response) => {
              setShippingOptions(response.data.shippings);
              setLoading(false);
              const shippingId = orderRebuy?.shipping_info?.id;
              if (shippingId) {
                const shippingOption = response?.data?.shippings?.find(
                  (s) => s.id === orderRebuy?.shipping_info?.id
                );
                if (shippingOption) {
                  setRadioSelected(shippingId);
                  props.setShippingSelected(shippingOption);
                  dispatch({
                    type: 'ADD_SHIPPING',
                    shippingMethod: shippingOption,
                  });
                }
              }
            });
        } else if (syncStatus === 'synced') {
          getSingleData('config', 3).then((data) => {
            setShippingOptions(data.shippings);
            setLoading(false);
          });
        }
      }
      setHasLargeDimensions(cart.products.some(product =>
        product?.height > 100 || product?.width > 100 || product?.length > 100 ||
        (product?.height + product?.width + product?.length) >= 200
      ));
    }
  }, [onlineStatus, syncStatus, activeCEP, buyerView, cart.returned, cart.products]);

  const onChange = (e) => {
    const shippingId = e.target.value;
    setRadioSelected(shippingId);
    const shippingOption = shippingOptions.find(
      (s) => s.id === shippingId
    );
    props.setShippingSelected(shippingOption);
    dispatch({
      type: 'ADD_SHIPPING',
      shippingMethod: shippingOption,
    });
  };

  return (
    <>
      <Divider orientation="left">Métodos de Entrega</Divider>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        {loading && activeCEP.value && (
          <Skeleton.Input style={{ width: 300 }} active />
        )}
        {!loading && (activeCEP.value || (!onlineStatus && syncStatus === 'synced')) && (
          <Row justify="start">
            <Col span={24}>
              <Card size="small">
                <Radio.Group onChange={onChange} value={radioSelected}>
                  <Space direction="vertical">
                    {shippingOptions
                      && shippingOptions.map((item) => {
                        let diaOrDias = false;
                        let prazo = false;

                        if (item.prazo) {
                          prazo = parseInt(item.prazo) + parseInt(item.days_add);
                          diaOrDias = prazo > 1 ? 'dias' : 'dia';
                        }

                        if (item.codigo_correios && hasLargeDimensions) {
                          item.disabled = true;
                        }

                        return (
                          <Radio key={item.id} value={item.id} disabled={item.disabled === true}>
                            {item.nome}
                            {' '}
                            {item.codigo_correios && hasLargeDimensions
                              ? '- Itens com tamanho excedido para envio'
                              : item.valor > 0 && ` - ${parseFloat(item.valor).toLocaleString(
                                'pt-BR',
                                {
                                  style: 'currency',
                                  currency: 'BRL',
                                },
                              )}`}
                            {' '}
                            {prazo && !hasLargeDimensions
                              && ` - Entrega em ${prazo} ${diaOrDias}`}
                          </Radio>
                        );
                      })}
                    {shippingOptions.length === 0 && (
                      <Alert
                        banner
                        message="Nenhum método de entrega disponível. "
                        type="warning"
                      />
                    )}
                  </Space>
                </Radio.Group>
              </Card>
            </Col>
          </Row>
        )}
        {!(activeCEP.value || (!onlineStatus && syncStatus === 'synced')) && (
          <Alert
            banner
            message="Preencha seu endereço para ver os métodos de entrega disponíveis."
            type="warning"
          />
        )}
        {props.shippingSelected.instructions && (
          <Row>
            <Col span={24}>
              <Card title="Instruções" size="small">
                <Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                  {props.shippingSelected.instructions}
                </Paragraph>
              </Card>
            </Col>
          </Row>
        )}
      </Space>
    </>
  );
}
